export enum ProvinceEnum {
    Unspecified = 0,
    EasternCape = 2,
    FreeState = 3,
    Gauteng = 4,
    KwaZuluNatal = 5,
    Limpopo = 6,
    Mpumalanga = 7,
    NorthWest = 8,
    NorthernCape = 9,
    WesternCape = 10,
}

